<template>
    <section class="page-section page-section--last">
        <div class="mb-60 mb-md-30">
            <div class="mb-10"><h3 class="text-28 text-md-20">스마트전자 확산, 제조실증 기반구축</h3></div>
            <div class="row">
                <div class="col-12 col-lg-6 order-lg-2">
                    <div class="img-wrap text-lg-right">
                        <img src="/images/sub/about/business-img2.png" alt="이미지" />
                    </div>
                </div>
                <div class="col-12 col-lg-6 order-lg-1">
                    <div class="text-items">
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업명</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">스마트전자 확산을 위한 제조실증 기반구축</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업기간</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">’21.4.1 ~ ’25.12.31 (5년)</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>지원내용</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">제품환류(제품 스케일업, 재설계 반복지원), 소비자실증 지원</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업목표</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">전자제품의 스마트화, 소량제조, 환류, 유지보수를 지원할 수 있는 집적기반구축과 맞춤형 제조실증 지원을 통해 전자기업을 육성함</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">1 </strong>비전</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <p class="card--shadow__txt page-text"><span class="color-primary">누구나 쉽게 혁신하자</span></p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">2 </strong>목표</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <p class="card--shadow__txt page-text"><span class="color-primary">용산 집적화를 통한 도심 전자생태계 확보</span></p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">3 </strong>전략</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt page-text">
                                <p>1. 제조, 개발자 제품의 소비 트랜드 반영</p>
                                <p>2. 도심내 설계, 조립, 유지보수 가능한 제조생태계 구축</p>
                                <p>3. 소비자 실증 및 환류가 가능한 제조기반 구축</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">4 </strong>구성</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt page-text">
                                <p>1. 고객반응 및 실증이 가능한 플렘폼 구축</p>
                                <p>2. 스마트 제품의 조립, 제조, 실증 기반</p>
                                <p>3. 전자개발, 제조기업을 위한 기술 집적지 구축</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style></style>
